import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { formatTime } from '../../../../../../utils/common.utils';

function ResendTimer() {
  const [time, setTime] = useState(2 * 60);

  useEffect(() => {
    const timer = setInterval(() => {
      if (time > 0) {
        setTime((prev) => prev - 1);
      }
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, [time]);

  return (
    <div className={styles.resendRow}>
      <div
        className={styles.resendTimer}
        style={{
          color: time > 0 ? '#fafafa' : '#F7F8FC7A',
        }}
      >
        {formatTime(time)}
      </div>
      <div
        className={styles.resentBtn}
        style={{
          color: time < 1 ? '#FFA586' : '#F7F8FC7A',
          fontWeight: time < 1 ? 600 : 400,
        }}
        onClick={() => time < 1 && setTime(2 * 60)}
      >
        RESEND OTP
      </div>
    </div>
  );
}

export default React.memo(ResendTimer);
